import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/first';

import { User } from '../models/user';
import { environment } from 'environments/environment';
import { BaseService } from './base.service';
import { GlobalService } from './global.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthService extends BaseService {

  constructor(
    public http: HttpClient,
    public global: GlobalService,
    public router: Router
  ) {
    super(http, 'api', '');
  }

  login(user): any {
    const body = {
      email: user.email,
      password: user.password
    };
    return this.http.post(environment.baseUrl + '/api/oauth/access_token', body);
  }

  register(user: User, clientId: number): Observable<any> {
    const body = {
      client_id: clientId,
      user
    };
    const url = environment.baseUrl + '/api/v2/client/register';
    return this.http.post(url, body);
  }

  isAuthenticated(): boolean {
    const token: string = sessionStorage.getItem('token');
    if (!token) {
      return false;
    }
    return true;
  }

  public logout() {
    sessionStorage.clear();
    this.global.token = null;
    this.global.loggedUser = null;
    setTimeout(() => {
      this.router.navigate(["/"]);
    });
}

  setSessionToken(data): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const token = 'Bearer' + ' ' + data.token;
      sessionStorage.setItem('token', token);
      this.global.token = data.token;
      this.getUserLogged().subscribe(res => {
        this.verifica().subscribe(verifica => {
          console.log("verifica", verifica);
          sessionStorage.setItem('asta_verifica', (verifica.success) ? '1' : '0');
          if (res.success === false) {
            resolve(false);
          } else {
            sessionStorage.setItem('loggedUser', JSON.stringify(res));
            this.global.loggedUser = res.data;
            resolve(true);
          }
        });
      }, err => reject(err));
    });
  }

  registerUser(user) {
      return this.createResource(user,{router:'v2/client/cad'});
  }

  verifica(): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/client/verifica', this.options());
  }

  complement(): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/admin/user/form', this.options());
  }

  complementSave(id: number, data: any): Observable<any> {
    return this.http.put(environment.baseUrl + '/api/v2/perfil/sobre/' + id, data, this.options());
  }

  getUserLogged(): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/client/user/authenticated', this.options());
  }

  userInfo(id): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/client/feed/userInfo/' + id, this.options());
  }

  verifyClient(clientId: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/api/v2/client/verifyclient', {client_id: clientId}, this.options());
  }

  dismissStorage(): void {
    sessionStorage.clear();
  }

  syncActiveClient(client: string): void {
    console.log('sync', client);
    sessionStorage.setItem('client', client);
  }

  getActiveClient(): any {
    return +sessionStorage.getItem('client');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts